/**
 * One failed request on the field-mapping screen: what failed, the reason given, and a way to retry.
 *
 * The reason is the server's own sentence, shown as it came. The title says which action it was,
 * because several can fail at once here and "This took too long" alone does not say what did.
 */
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle, Button } from '@design-system';
import { fieldMapCopy } from '../lib/field-map-copy';

interface FieldMapAlertProps {
  title: string;
  error: unknown;
  onRetry?: () => void;
  className?: string;
}

export function FieldMapAlert({ title, error, onRetry, className }: FieldMapAlertProps) {
  return (
    <Alert
      variant="destructive"
      className={className}
    >
      <AlertCircle />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        <p>{(error as Error).message}</p>
        {onRetry && (
          <Button
            variant="outline"
            size="sm"
            className="mt-2"
            onClick={onRetry}
          >
            {fieldMapCopy.alerts.tryAgain}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
